import { FC } from 'react';

import { Box, rem } from '@bonusly/design-system';

interface KeyBoxProps {
	children: string;
}

export const KeyBox: FC<KeyBoxProps> = ({ children }) => {
	return (
		<Box bg="gray.800" borderRadius={rem(5)} fontSize={1} px={rem(5)}>
			{children}
		</Box>
	);
};
